import React from 'react';
import { connect } from 'react-redux';

import BlogsComponent from '../../components/app/Blogs/BlogListings/Blogs';
import * as actions from '../../actions/blog/blogListings';

const Blogs = (props) => {
  return (
    <BlogsComponent {...props}/>
  );
};

export default connect(({ blog }) => blog.blogListings, actions)(Blogs);
